module.exports = __webpack_public_path__ + "static/media/Email.e1d41171.png";